<a-header stream-title="Edu Admin" padding="false">
  <a-header-item
    slot="start"
    routerLink="/user"
    routerLinkActive
    #userLink="routerLinkActive"
    [attr.active]="userLink.isActive ? '' : null"
  >
    Gebruikersinformatie
  </a-header-item>
</a-header>
